import { render, staticRenderFns } from "./ExamsRequestList.vue?vue&type=template&id=b196dd14&scoped=true"
import script from "./ExamsRequestList.vue?vue&type=script&lang=js"
export * from "./ExamsRequestList.vue?vue&type=script&lang=js"
import style0 from "./ExamsRequestList.vue?vue&type=style&index=0&id=b196dd14&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b196dd14",
  null
  
)

export default component.exports